'use strict'; // Load modules

var _classCallCheck = require("C:\\repos\\tabletopalley\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\repos\\tabletopalley\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\repos\\tabletopalley\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\repos\\tabletopalley\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\repos\\tabletopalley\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var Any = require('../any');

var Hoek = require('hoek'); // Declare internals


var internals = {};

internals.Binary =
/*#__PURE__*/
function (_Any) {
  _inherits(_class, _Any);

  function _class() {
    var _this;

    _classCallCheck(this, _class);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this));
    _this._type = 'binary';
    return _this;
  }

  _createClass(_class, [{
    key: "_base",
    value: function _base(value, state, options) {
      var result = {
        value: value
      };

      if (typeof value === 'string' && options.convert) {
        try {
          result.value = Buffer.from(value, this._flags.encoding);
        } catch (e) {}
      }

      result.errors = Buffer.isBuffer(result.value) ? null : this.createError('binary.base', null, state, options);
      return result;
    }
  }, {
    key: "encoding",
    value: function encoding(_encoding) {
      Hoek.assert(Buffer.isEncoding(_encoding), 'Invalid encoding:', _encoding);

      if (this._flags.encoding === _encoding) {
        return this;
      }

      var obj = this.clone();
      obj._flags.encoding = _encoding;
      return obj;
    }
  }, {
    key: "min",
    value: function min(limit) {
      Hoek.assert(Number.isSafeInteger(limit) && limit >= 0, 'limit must be a positive integer');
      return this._test('min', limit, function (value, state, options) {
        if (value.length >= limit) {
          return value;
        }

        return this.createError('binary.min', {
          limit: limit,
          value: value
        }, state, options);
      });
    }
  }, {
    key: "max",
    value: function max(limit) {
      Hoek.assert(Number.isSafeInteger(limit) && limit >= 0, 'limit must be a positive integer');
      return this._test('max', limit, function (value, state, options) {
        if (value.length <= limit) {
          return value;
        }

        return this.createError('binary.max', {
          limit: limit,
          value: value
        }, state, options);
      });
    }
  }, {
    key: "length",
    value: function length(limit) {
      Hoek.assert(Number.isSafeInteger(limit) && limit >= 0, 'limit must be a positive integer');
      return this._test('length', limit, function (value, state, options) {
        if (value.length === limit) {
          return value;
        }

        return this.createError('binary.length', {
          limit: limit,
          value: value
        }, state, options);
      });
    }
  }]);

  return _class;
}(Any);

module.exports = new internals.Binary();